<script setup>
defineProps({
  affiliations: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <span class="event-affiliation-line">
    <span v-for="(group, groupIndex) in affiliations" :key="groupIndex" class="affiliation-group">
      <template v-if="groupIndex > 0">{{ ' ' }}</template>
      <template v-if="group.label">{{ group.label }}</template>
      <template v-if="group.label && group.items.length">{{ ' (' }}</template>
      <template v-for="(item, itemIndex) in group.items" :key="itemIndex">
        <template v-if="itemIndex > 0">{{ ', ' }}</template>
        <template v-if="item.abbr">
          <span aria-hidden="true">{{ item.abbr }}</span>
          <span class="visually-hidden">{{ item.value }}</span>
        </template>
        <template v-else>{{ item.value }}</template>
      </template>
      <template v-if="group.label && group.items.length">{{ ')' }}</template>
    </span>
  </span>
</template>
